import { DatePipe } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/Services/Common/common.service';
import { HttpRequestService } from 'src/app/Services/Http/http-request.service';
import { PropertiesService } from 'src/app/Services/Properties/properties.service';
import { SearchService } from 'src/app/Services/search.service';
declare var $: any;

@Component({
  selector: 'app-carrier-applied',
  templateUrl: './carrier-applied.component.html',
  styleUrls: ['./carrier-applied.component.css']
})
export class CarrierAppliedComponent implements OnInit {
  subscription: Subscription;
  reportForm: FormGroup;
  today = new Date();
  searchInvoiceColumns: any[];
  @Output() searchItem: EventEmitter<any> = new EventEmitter();
  searchInvoiceAdapter: any;
  searchInvoiceSource: any;
  constructor(private httpRequestService: HttpRequestService,
    private searchService: SearchService,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    public commonService: CommonService,
    private router: Router, private property: PropertiesService) {
    this.createForm();
    // this.subscription = searchService.searchRefreshEvt$.subscribe(() => {
    //   this.getGridData();
    // });
  }

  createForm() {
    this.reportForm = this.formBuilder.group({
      Date1: [],
      Date2: []
    })
  }

  ngOnInit() {
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    this.reportForm.get("Date1").setValue(firstDay);
    this.reportForm.get("Date2").setValue(this.today);
    this.getGridData();
  }

  ngAfterViewInit(): void {
    this.getGridData();
  }

  GridInit() {
    this.searchInvoiceColumns =
      [
        {
          text: 'S.No', width: '5%', sortable: false, menu: false, cellsrenderer: function (row, cell, value) {
            return '<div style="text-align: center; margin-top: 10px;">' + (1 + row) + '</div>';
          }
        },
        { text: 'Region', datafield: 'Region', width: '10%' },
        { text: 'Category', datafield: 'Category', width: '12%' },
        { text: 'Position', datafield: 'Position', width: '12%' },
        { text: 'Name', datafield: 'Name', width: '15%' },
        { text: 'Email', datafield: 'Email', width: '13%' },
        { text: 'Mobile', datafield: 'Mobile', width: '10%' },
        { text: 'Applied', datafield: 'Applied', width: '15%',cellsformat: "dd/MM/yyyy" },
        // { text: 'isEmail', datafield: 'isEmail', width: '10%' },
        // {
        //   text: 'Resume', width: '8%', datafield: 'Path', columntype: 'custom',
        //   // createeditor: (row: number, value: any, editor: any): void => {
        //   //   var textBox = $("<button class='jqx-rc-all jqx-button jqx-widget jqx-element-container jqx-fill-state-normal jqx-primary' id='linkButton'> Download </button>").appendTo(editor);
        //   //   $(textBox).click(function () {
        //   //     setTimeout(function () {
        //   //       $('#searchInvoiceGrid').jqxGrid('selectrow', row);
        //   //       this.AcceptBooking(row);
        //   //     }, 0);
        //   //   })
        //   // },
        //   cellsrenderer: function (row) {
        //     return "<button class='jqx-rc-all jqx-button jqx-widget jqx-element-container jqx-fill-state-normal jqx-primary' type='button'> View </button>";
        //   },
        //   buttonclick: function (row) {
        //     alert("click");
        //     $('#searchInvoiceGrid').jqxGrid('selectrow', row);
        //     this.OpenResume(row);
        //   },
        // },
        // {
        //   text: 'Resume', datafield: 'Path', width: '8%', editable: true, hidden: false,
        //    cellbeginedit: function (row, datafield, columntype) {
        //      alert('datafield: ' + datafield);
        //   //  var inNumber = $('.containerSRGrid').jqxGrid('getcellvalue', row, 'TallyPosted');
        //     // if (inNumber != 0) {
        //     //     return false;
        //     // }
        //   },
        //   cellsrenderer: function (row, cell, value){
        //     var filenme = $('.searchInvoiceGrid').jqxGrid('getcellvalue', row, 'Path');
        //     return "<div style='margin: 7px 0 0 15px;' onclick='downloadFile(1)'><i class='fa fa-download'> View </i></div>";
        //   }
        // },

      ];

    this.searchInvoiceSource =
    {
      datatype: 'json',
      datafields: [
        { name: 'Region', type: 'string' },
        { name: 'Category', type: 'string' },
        { name: 'Position', type: 'string' },
        { name: 'Name', type: 'string' },
        { name: 'Email', type: 'string' },
        { name: 'Mobile', type: 'string' },
        { name: 'Applied', type: 'date' },
        // { name: 'isEmail', type: 'string' },
        // { name: 'Path', type: 'string' },
      ],
      id: 'careerid',
      localdata: ''
    };
  }

  getGridData() {
    this.getData().then((list: any) => {
      this.GridInit();
      this.searchInvoiceSource.localdata = list.result;
      this.searchInvoiceAdapter = new jqx.dataAdapter(this.searchInvoiceSource);
    });

  }
  getData() {
    return new Promise((resolve, reject) => {
      this.httpRequestService.get(this.property.WebAPIipAndPort.concat(this.property.BSSAPI) + "/Job_List/Get_Career_Applied?Date1=" + this.datePipe.transform(this.reportForm.get('Date1').value, 'dd-MM-yyyy') + "&Date2=" + this.datePipe.transform(this.reportForm.get('Date2').value, 'dd-MM-yyyy'))
        .then((res: any) => {
          console.log('Response', res);
          if (res.status == 200) {
            resolve(res);
          }
        }, (error) => {
          reject(error);
        });
    });
  }

  OpenResume(row) {
    alert("open");
    let CareerData = $(".searchGrid").jqxGrid('getrowdata', row);
    if (CareerData.Path) {
      var fileURL = this.property.WebAPIipAndPort + CareerData.Path;
      window.open(fileURL);
    }
  }

  downloadFile(fileName) {
    alert(fileName);
    // this.httpRequestService.get(this.property.WebAPIipAndPort + "/FileStorage/downloadFile?fileName=" + fileName + '&FolderName=Careers')
    //   .subscribe((data: any) => {
    //     this.progressBarShow = false;
    //     if (data && data.response) {
    //       let binaryString = window.atob(data.response);
    //       let binaryLen = binaryString.length;
    //       let bytes = new Uint8Array(binaryLen);
    //       for (let i = 0; i < binaryLen; i++) {
    //         let ascii = binaryString.charCodeAt(i);
    //         bytes[i] = ascii;
    //       }
    //       let file = new Blob([bytes], { type: data.status });
    //       var fileURL = URL.createObjectURL(file);
    //       window.open(fileURL);
    //     }
    //   });
  }

}
